import React, { useContext } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Link } from 'gatsby';
import { ThemeModeContext } from '~theme-provider';
import { SiteContentWrapper, Container, Row, Col } from '~layout';
import { AssetRenderer } from '~helpers';
import { H3, Small } from '~typography';
import FooterContentWrapper from './FooterContentWrapper';
import LogoContainer from './LogoContainer';
import MissionContentContainer from './MissionContentContainer';

var DefaultFooter = function DefaultFooter(_ref) {
  var logoPath = _ref.logoPath,
      logoPathAlt = _ref.logoPathAlt,
      logoWidth = _ref.logoWidth,
      logoHeight = _ref.logoHeight,
      missionTitle = _ref.missionTitle,
      missionContent = _ref.missionContent,
      copyrightOwner = _ref.copyrightOwner,
      details = _ref.details,
      intl = _ref.intl,
      isFullWidth = _ref.isFullWidth,
      showDivider = _ref.showDivider;

  var _useContext = useContext(ThemeModeContext),
      themeMode = _useContext.themeMode;

  return /*#__PURE__*/React.createElement(FooterContentWrapper, {
    showDivider: showDivider
  }, /*#__PURE__*/React.createElement(SiteContentWrapper, {
    isFullWidth: isFullWidth
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Row, {
    justifyContent: "center"
  }, logoPath && /*#__PURE__*/React.createElement(Col, {
    xxs: 30
  }, /*#__PURE__*/React.createElement(LogoContainer, null, /*#__PURE__*/React.createElement(Link, {
    to: "/",
    "aria-label": intl.formatMessage({
      id: 'footer.logo.home.label'
    })
  }, /*#__PURE__*/React.createElement(AssetRenderer, {
    assetPath: themeMode === 'darkMode' ? logoPathAlt : logoPath,
    assetWidth: logoWidth,
    assetHeight: logoHeight
  })))), /*#__PURE__*/React.createElement(Col, {
    xxs: 30,
    md: 14
  }, missionTitle && /*#__PURE__*/React.createElement(H3, null, missionTitle), missionContent && /*#__PURE__*/React.createElement(MissionContentContainer, null, missionContent)), /*#__PURE__*/React.createElement(Col, {
    xxs: 30,
    md: 16
  }, /*#__PURE__*/React.createElement(Row, {
    justifyContent: "flex-end"
  }, /*#__PURE__*/React.createElement(Col, {
    xxs: 30
  }, details))))), /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Row, {
    justifyContent: "center"
  }, /*#__PURE__*/React.createElement(Col, {
    xxs: 30
  }, /*#__PURE__*/React.createElement(Small, {
    color: "muted"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "footer.copyrights.label",
    values: {
      currentYear: new Date().getFullYear(),
      copyrightOwner: copyrightOwner
    }
  })))))));
};

DefaultFooter.defaultProps = {
  logoPath: undefined,
  logoPathAlt: undefined,
  logoWidth: undefined,
  logoHeight: undefined,
  missionTitle: undefined,
  missionContent: undefined,
  details: undefined,
  isFullWidth: false,
  showDivider: false
};
export default injectIntl(DefaultFooter);